import React from 'react';
import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { LogoIcon } from '@/components/common/Logo';
import { Button } from '@/components/ui/button';
import { useSidebarStore } from '@/stores/useSidebarStore';

const routeTitleMap: Record<string, { title: string; subtitle?: string }> = {
  '/conversations': { title: 'Conversas', subtitle: 'Atendimento com Agente de IA e equipe' },
  '/customers': { title: 'CRM de Clientes', subtitle: 'Histórico e dados unificados dos seus clientes' },
  '/integrations': { title: 'Lojas Conectadas', subtitle: 'Conecte suas lojas Shopify e Nuvemshop' },
  '/preferences': { title: 'Configurações do Agente', subtitle: 'Personalize o Agente de IA e o visual do chat' },
  '/profile': { title: 'Meu Perfil', subtitle: 'Gerencie seus dados e notificações' },
  '/billing': { title: 'Planos e Assinatura', subtitle: 'Gerencie seu plano e consumo mensal' },
};

export const Header: React.FC = () => {
  const { setMobileOpen } = useSidebarStore();
  const location = useLocation();

  // Determine current page info
  let currentMeta = routeTitleMap[location.pathname];
  if (!currentMeta && location.pathname.startsWith('/conversations/')) {
    currentMeta = { title: 'Conversas', subtitle: 'Conversa de chat ativa' };
  }
  if (!currentMeta) {
    currentMeta = { title: 'Workspace Tales', subtitle: 'Automação de Suporte ao Cliente' };
  }

  return (
    <header className="h-16 border-b border-border/70 bg-card/80 backdrop-blur-md px-4 sm:px-6 flex items-center justify-between flex-shrink-0 z-20">
      {/* Left section: Hamburger (mobile) + Page Title */}
      <div className="flex items-center gap-3">
        {/* Mobile drawer trigger */}
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden h-9 w-9 text-muted-foreground hover:text-foreground"
          onClick={() => setMobileOpen(true)}
          aria-label="Abrir menu de navegação móvel"
        >
          <Menu className="h-5 w-5" />
        </Button>

        {/* Mobile Brand Logo */}
        <div className="md:hidden flex items-center">
          <LogoIcon className="h-6 w-6 text-primary" />
        </div>

        {/* Desktop / Mobile Title */}
        <div className="flex flex-col">
          <h1 className="text-base sm:text-lg font-bold tracking-tight text-foreground leading-none">
            {currentMeta.title}
          </h1>
          {currentMeta.subtitle && (
            <p className="text-xs text-muted-foreground hidden sm:block mt-0.5">
              {currentMeta.subtitle}
            </p>
          )}
        </div>
      </div>

    </header>
  );
};
